import { EnumScreenName, EventProperties } from '@calm/evexia-analytics';
import { Link } from '@rhg/libs/material';
import NextLink from 'next/link';
import { Ref, forwardRef } from 'react';

export type CHLinkProps = React.ComponentProps<typeof Link> &
    React.ComponentProps<typeof NextLink> & {
        trackButton?: string;
        trackProps?: EventProperties;
        trackScreen?: EnumScreenName;
    };

export const ChLink = forwardRef(function CHLink(
    props: CHLinkProps,
    ref: Ref<HTMLAnchorElement>
) {
    // Extra safety -- We need to remove these props because they throw an error when rendered.
    const {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        trackButton: _trackButton,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        trackProps: _trackProps,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        trackScreen: _trackScreen,
        ...otherProps
    } = props;
    return <Link ref={ref} {...otherProps} component={NextLink} />;
});
